import React from 'react'

interface SkeletonBoxProps {
  /** 自定义类名，用于控制宽高、圆角、颜色等样式 */
  className?: string
}

const SkeletonBox: React.FC<SkeletonBoxProps> = ({
  className = '',
}) => {
  return (
    <div className="animate-pulse">
      <div className={`bg-[#F4F5F6] ${className}`} />
    </div>
  )
}

export default SkeletonBox
